(() => {
  if (window.__damEuCookieLoaded) return;
  window.__damEuCookieLoaded = true;
  const source = document.currentScript;
  const cssUrl = source && source.dataset.cookieCss;
  const purposes = ['analytics', 'marketing', 'preferences'];
  let attempts = 0;
  function start() {
    const shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) return mount(shopify.customerPrivacy);
    if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
        if (!error && shopify.customerPrivacy) mount(shopify.customerPrivacy);
      });
      return;
    }
    if (++attempts < 40) setTimeout(start, 250);
  }
  function mount(api) {
    let country;
    try { country = String(api.getRegion() || '').slice(0,2).toUpperCase(); } catch { return; }
    if (!['DE','FR','ES'].includes(country) || document.getElementById('dam-eu-cookie-host')) return;
    const lang = document.documentElement.lang;
    let copy;
    try { copy = JSON.parse(document.getElementById('dam-eu-cookie-copy').textContent); } catch { return; }
    const host = document.createElement('div');
    host.id = 'dam-eu-cookie-host'; host.lang = lang; host.dataset.country = country;
    const link = document.createElement('link'); link.rel = 'stylesheet'; link.href = cssUrl;
    if (!cssUrl) return;
    host.hidden = true;
    link.onload = () => { host.hidden = false; };
    document.head.append(link);
    host.innerHTML = `<section id="dam-eu-cookie-banner" role="dialog" aria-modal="false" aria-labelledby="dam-eu-cookie-banner__body-title"><div class="dam-eu-cookie-banner__wrapper"><div class="dam-eu-cookie-banner__body"><h2 id="dam-eu-cookie-banner__body-title"></h2><p><span data-copy="body"></span> <a data-policy></a></p></div><div class="dam-eu-cookie-banner__btns"><button id="dam-eu-cookie-banner__btn-decline" type="button"></button><button id="dam-eu-cookie-banner__btn-accept" type="button"></button><button id="dam-eu-cookie-banner__btn-manage-prefs" type="button" aria-haspopup="dialog"></button></div><p role="status" data-banner-status></p></div></section><button id="dam-eu-cookie-reopen" type="button" aria-haspopup="dialog" hidden></button><dialog id="dam-eu-cookie-prefs" aria-labelledby="dam-eu-cookie-prefs-title"><h2 id="dam-eu-cookie-prefs-title"></h2><p data-copy="note"></p><div class="dam-eu-cookie-necessary"><span data-copy="necessary"></span><small data-copy="always"></small></div><div data-options></div><p role="status" data-prefs-status></p><div class="dam-eu-cookie-actions"><button data-back type="button"></button><button data-save type="button"></button></div></dialog>`;
    host.querySelectorAll('[data-copy]').forEach(n => { n.textContent = copy[n.dataset.copy]; });
    const banner = host.querySelector('#dam-eu-cookie-banner');
    const dialog = host.querySelector('dialog');
    const reopen = host.querySelector('#dam-eu-cookie-reopen');
    const manage = host.querySelector('#dam-eu-cookie-banner__btn-manage-prefs');
    const accept = host.querySelector('#dam-eu-cookie-banner__btn-accept');
    const decline = host.querySelector('#dam-eu-cookie-banner__btn-decline');
    const saveButton = host.querySelector('[data-save]');
    const back = host.querySelector('[data-back]');
    const statusBanner = host.querySelector('[data-banner-status]');
    const statusPrefs = host.querySelector('[data-prefs-status]');
    host.querySelector('#dam-eu-cookie-banner__body-title').textContent = copy.title;
    host.querySelector('#dam-eu-cookie-prefs-title').textContent = copy.manage;
    accept.textContent = copy.accept; decline.textContent = copy.reject;
    manage.textContent = reopen.textContent = copy.manage;
    back.textContent = copy.back; saveButton.textContent = copy.save;
    const policy = host.querySelector('[data-policy]');
    policy.textContent = copy.privacy;
    policy.href = new URL((window.Shopify.routes?.root || '/') + 'policies/privacy-policy', location.origin).href;
    policy.target = '_blank'; policy.rel = 'noopener noreferrer';
    purposes.forEach(key => {
      const label = document.createElement('label'); label.append(document.createTextNode(copy[key]));
      const input = document.createElement('input'); input.type = 'checkbox'; input.name = key;
      label.append(input); host.querySelector('[data-options]').append(label);
    });
    document.body.append(host);
    let pending = false;
    let pendingFinish = null;
    let previousFocus = null;
    function consent() { try { return api.currentVisitorConsent(); } catch { return {}; } }
    function sync() {
      const values = consent();
      const answered = purposes.every(k => ['yes','no'].includes(values[k]));
      banner.hidden = answered; reopen.hidden = !answered;
      host.dataset.choice = answered ? 'recorded' : 'unanswered';
    }
    function busy(value) {
      pending = value;
      [accept,decline,manage,reopen,saveButton,back].forEach(n => { n.disabled = value; });
      dialog.querySelectorAll('input').forEach(n => { n.disabled = value; });
    }
    function showPreferences() {
      if (pending) return;
      previousFocus = document.activeElement;
      const values = consent();
      dialog.querySelectorAll('input').forEach(n => { n.checked = values[n.name] === 'yes'; });
      statusPrefs.textContent = '';
      if (!dialog.open) dialog.showModal();
    }
    function save(values) {
      if (pending) return;
      busy(true); statusBanner.textContent = ''; statusPrefs.textContent = '';
      const status = dialog.open ? statusPrefs : statusBanner;
      status.textContent = copy.saving;
      let finished = false;
      const finish = error => {
        if (finished) return;
        const actual = consent();
        const confirmed = purposes.every(k => actual[k] === (values[k] ? 'yes' : 'no'));
        if (!confirmed && !error) return;
        finished = true; clearTimeout(timer); busy(false); pendingFinish = null;
        if (!confirmed) { status.textContent = copy.error; return; }
        status.textContent = ''; if (dialog.open) dialog.close(); sync(); reopen.focus({preventScroll:true});
      };
      const timer = setTimeout(() => finish(true), 10000);
      pendingFinish = finish;
      try { api.setTrackingConsent(values, () => finish(false)); } catch { finish(true); }
    }
    accept.addEventListener('click', () => save({analytics:true,marketing:true,preferences:true}));
    decline.addEventListener('click', () => save({analytics:false,marketing:false,preferences:false}));
    manage.addEventListener('click', showPreferences); reopen.addEventListener('click', showPreferences);
    back.addEventListener('click', () => dialog.close());
    dialog.addEventListener('cancel', e => { if (pending) e.preventDefault(); });
    dialog.addEventListener('close', () => { if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll:true}); });
    saveButton.addEventListener('click', () => save(Object.fromEntries([...dialog.querySelectorAll('input')].map(n => [n.name,n.checked]))));
    document.addEventListener('visitorConsentCollected', () => {
      if (pending && pendingFinish) pendingFinish(false);
      else sync();
    });
    window.addEventListener('pageshow', sync);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
